import styled from "styled-components";
import { Tag as TagBase } from "antd";

export const Tag = styled(TagBase)`
  border-radius: 1em;
  min-width: 100px;
  text-align: center;
`;

export const ProductLink = styled.div`
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
